// extracted by mini-css-extract-plugin
export default {"table":"style_table__HUV6u","tab":"style_tab__lh88u","active":"style_active__ibYyX","new":"style_new__Uc3Tw","dropdown":"style_dropdown__k+jnr","isNew":"style_isNew__Le15C"};